export const SNOWPACK_PUBLIC_WEB_URL = import.meta.env.VITE_PUBLIC_WEB_URL
